import ReactDOM from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import App from './App.tsx'

registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return

    let checking = false
    const checkForUpdate = async () => {
      if (
        checking ||
        registration.installing ||
        !navigator.onLine ||
        document.visibilityState !== 'visible'
      )
        return

      checking = true
      try {
        await registration.update()
      } catch {
        // Retry on the next check if the connection is unavailable.
      } finally {
        checking = false
      }
    }

    document.addEventListener('visibilitychange', checkForUpdate)
    window.addEventListener('focus', checkForUpdate)
    window.addEventListener('online', checkForUpdate)
    window.setInterval(checkForUpdate, 5 * 60 * 1000)
  },
})

declare global {
  interface Window {
    env: {
      API_ENDPOINT: string
    }
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
